import { useBasicPopup } from '../../../components/basic/popup/BasicPopup'
import { useBottomSheet } from '../../../components/basic/popup/BottomSheet'
import MaterialBottomSheet from '../../../components/modal/MaterialBottomSheet'
import MaterialModal from '../../../components/modal/MaterialModal'
import MaterialSelectButton from '../../../components/trial/MaterialSelectButton'
import apis from '../../../modules/apis'
import { axiosGet } from '../../../modules/axiosHelper'
import useIsMobile from './useIsMobile'

export const useOpenMaterialPopup = () => {
  const basicPopup = useBasicPopup()
  const bottomSheet = useBottomSheet()
  const isMobileEnv = useIsMobile()

  return async (e, id, isMobile?, isTrial?) => {
    e.preventDefault()
    e.stopPropagation()
    const res = await axiosGet(apis.course.detail({ id: id }))

    if (res.success) {
      if (!isMobileEnv) {
        basicPopup.show({
          id: 'packet-modal',
          maxW: 1096,
          maxH: 'calc(84vh - 98px)',
          bodyPx: 40,
          bodyPb: isTrial && 20,
          titlePx: 40,
          titlePt: 40,
          titlePb: 24,
          closeButtonRightPixel: 40,
          closeButtonTopPixel: 40,
          bottomButton: isTrial && (
            <div className="mb-[48px] mr-[48px] flex justify-end">
              <MaterialSelectButton materialId={res?.course?.id} />
            </div>
          ),
          titleCentered: false,
          title: res.course.title,
          wrapperClassName: 'border-1 border-gray-300 mx-[40px] mb-[40px] rounded-[4px]',
          body: <MaterialModal data={res} isMobile={isMobile} isTrial={isTrial} />,
        })
      } else {
        bottomSheet.show({
          id: 'material-bottom-sheet',
          body: <MaterialBottomSheet data={res} />,
          bottombarContent: isTrial && (
            <div className="z-2000 fixed bottom-0 left-0 flex h-[104px] w-full items-start justify-center bg-white pt-[12px] ">
              <MaterialSelectButton materialId={res?.course?.id} />
            </div>
          ),
        })
      }
    }
  }
}
